export default "__VITE_ASSET__qt88b0zt__"